
import React, { useState, useEffect } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { KeyAsk } from "../types";

interface KeyRequestsDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onSave: (askData: Omit<KeyAsk, 'id'>) => void;
  editingAsk: KeyAsk | null;
}

export const KeyRequestsDialog = ({ isOpen, onClose, onSave, editingAsk }: KeyRequestsDialogProps) => {
  const [formData, setFormData] = useState({
    requestor_name: '',
    request_description: '',
    action_by: '',
    approver: '',
    expected_completion_date: '',
    status: ''
  });

  useEffect(() => {
    if (editingAsk) {
      setFormData({
        requestor_name: editingAsk.requestor_name || '',
        request_description: editingAsk.request_description || '',
        action_by: editingAsk.action_by || '',
        approver: editingAsk.approver || '',
        expected_completion_date: editingAsk.expected_completion_date ? 
          new Date(editingAsk.expected_completion_date).toISOString().split('T')[0] : '',
        status: editingAsk.status || ''
      });
    } else {
      setFormData({
        requestor_name: '',
        request_description: '',
        action_by: '',
        approver: '',
        expected_completion_date: '',
        status: ''
      });
    }
  }, [editingAsk, isOpen]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSave(formData);
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="bg-white text-black">
        <DialogHeader>
          <DialogTitle>{editingAsk ? 'Edit Key Request' : 'Add New Key Request'}</DialogTitle>
        </DialogHeader>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <Label htmlFor="requestor_name">Requestor Name</Label>
            <Input
              id="requestor_name"
              className="bg-wite text-black"
              value={formData.requestor_name}
              onChange={(e) => setFormData({...formData, requestor_name: e.target.value})}
              required
            />
          </div>
          <div>
            <Label htmlFor="request_description">Request Description</Label>
            <Input
              id="request_description"
              className="bg-wite text-black"
              value={formData.request_description}
              onChange={(e) => setFormData({...formData, request_description: e.target.value})}
              required
            />
          </div>
          <div>
            <Label htmlFor="action_by">Action By</Label>
            <Input
              id="action_by"
              className="bg-wite text-black"
              value={formData.action_by}
              onChange={(e) => setFormData({...formData, action_by: e.target.value})}
              required
            />
          </div>
          <div>
            <Label htmlFor="approver">Approver</Label>
            <Input
              id="approver"
              className="bg-wite text-black"
              value={formData.approver}
              onChange={(e) => setFormData({...formData, approver: e.target.value})}
              required
            />
          </div>
          <div>
            <Label htmlFor="expected_completion_date">Expected Completion Date</Label>
            <Input
              id="expected_completion_date"
              className="bg-wite text-black"
              type="date"
              value={formData.expected_completion_date}
              onChange={(e) => setFormData({...formData, expected_completion_date: e.target.value})}
              required
            />
          </div>
          <div>
            <Label htmlFor="status">Status</Label>
            <Input
              id="status"
              className="bg-wite text-black"
              value={formData.status}
              onChange={(e) => setFormData({...formData, status: e.target.value})}
              required
            />
          </div>
          <Button type="submit" className="w-full">
            {editingAsk ? 'Update' : 'Add'} Request
          </Button>
        </form>
      </DialogContent>
    </Dialog>
  );
};
